import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React, { useMemo } from "react";
import { ReactComponent as ObjectiveIcon } from "Assets/Icons/Classroom/ObjectiveIcon.svg";
import { ReactComponent as CodeIcon } from "Assets/Icons/Classroom/CodeIcon.svg";
import { ReactComponent as SQLEditorIcon } from "Assets/Icons/Classroom/SQLEditor.svg";
import { ReactComponent as BookmarkIcon } from "Assets/Icons/Classroom/BookmarkIcon.svg";
import { ReactComponent as HelpIcon } from "Assets/Icons/Classroom/HelpIcon.svg";
import { ReactComponent as FileIcon } from "Assets/Icons/Classroom/FileIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { bookmarkQuestion } from "Slices/thunks";
import { useNavigate, useParams } from "react-router-dom";

const AllQuestions = ({ setSelectedQue, questions }) => {
  const { id = 0, sessionId = 0, tab } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Course || {},
  }));

  const columns = useMemo(() => {
    const col = [
      { label: Translation?.NameOfTheProblem, accessor: "name" },
      { label: Translation?.Type, accessor: "type" },
      {
        accessor: "difficulty",
        label: Translation?.Difficulty,
      },
      {
        accessor: "score",
        label: Translation?.Score,
      },
      {
        accessor: "status",
        label: Translation?.Status,
      },
      {
        accessor: "submission",
        label: Translation?.Submissions,
      },
      {
        accessor: "asked_in",
        label: Translation?.AskedIn,
      },
      {
        accessor: "actions",
        label: Translation?.Actions,
      },
      {
        accessor: "solved_by",
        label: Translation?.SolvedBy,
      },
    ];
    return col.filter((c) => tab === "problems" && c.accessor === "score" ? false : true)
  }, [Translation, tab]) 

  const handleBookmark = (question) => {
    const questionObj = {
      ID: question.BookmarkID,
      SessionID: question.SessionID,
      QuestionID: question.ID,
    }
 
    dispatch(bookmarkQuestion(questionObj))
  }

  return (
    <TableContainer>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {columns.map((column, i) => (
              <TableCell key={i}>{column.label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {questions?.map((item, index) => {
            return (
              <TableRow hover key={`bodyRow${index}`}>
                {columns.map((column, i) => {
                  return (
                    <TableCell key={`bodyCol${i}`}>
                      {column?.accessor == "type" ? (
                        <PrimaryIcon icon={item.QuestionTypeID === 5 ? SQLEditorIcon : item.QuestionTypeID === 6 ? CodeIcon : ObjectiveIcon} fill={false} />
                      ) : column?.accessor == "difficulty" ? (
                        <Typography color="secondary.light">{item.DifficultyName}</Typography>
                      ) : column?.accessor == "score" ? (
                          <Typography color="secondary.light">{`${item.YourScore || '0.0'}/${item.MaxScore}`}</Typography>
                      ) : column?.accessor == "status" ? (
                        <Typography
                          sx={(theme) => ({
                            // background: theme.palette.border.blue,
                            background: item.IsSelectedOptionCorrect ? theme.palette.success.light : item.CurrentAttempt > 0 ? theme.palette.warning.main : theme.palette.error.light,
                            padding: "6px 16px",
                            borderRadius: "8px",
                          })}
                          color="secondary.light"
                        >
                          {item.IsSelectedOptionCorrect ? Translation?.Solved : item.CurrentAttempt > 0 ? Translation?.Attempted : Translation?.Unsolved }
                        </Typography>
                      ) : column?.accessor == "submission" ? (
                        <Typography color="secondary.light">
                          {item.CurrentAttempt > 0 ? `${item.CurrentAttempt} ${Translation?.Submissions}` : Translation?.NoSubmissions }
                        </Typography>
                      ) : column?.accessor == "asked_in" ? (
                        <Typography color="secondary.light">-</Typography>
                      ) : column?.accessor == "actions" ? (
                        <Box display={"flex"} alignItems={"center"}>
                          <IconButton size="small" onClick={() => handleBookmark(item)}>
                            <PrimaryIcon icon={BookmarkIcon}
                              cursor="pointer"
                              color={item.BookmarkID ? "yellow" : ""}
                            />
                          </IconButton>
                          <IconButton size="small" onClick={() => navigate(`/session/${id}/${sessionId}/help`)}>
                            <PrimaryIcon icon={HelpIcon}
                              cursor="pointer"
                             />
                          </IconButton>
                          <IconButton size="small">
                            <PrimaryIcon icon={FileIcon} />
                          </IconButton>
                          <Button
                            sx={{ marginLeft: "30px" }}
                            variant="contained"
                            color={item.IsSelectedOptionCorrect ? "success" : "primary"}
                            onClick={() => setSelectedQue(index + 1)}
                          > 
                            {item.IsSelectedOptionCorrect ? Translation?.Solved : Translation?.Solve}
                            {/* Solve */}
                          </Button>
                        </Box>
                      ) : column?.accessor == "solved_by" ? (
                        <Typography color="secondary.light">{item.SolvedCount}</Typography>
                      ) : (
                        <Typography color="secondary.light">
                          {/* Q1. Frame work for weight loss */}
                          {item.QuestionTitle}
                        </Typography>
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AllQuestions;
